let inject = ['$scope', '$state', '$uibModalInstance', 'modalOptions', 'SharedService','$timeout', 'ngAuthSettings', 'SessionService'];

class ModalLocationController {

    constructor($scope, $state, $uibModalInstance, modalOptions, SharedService,$timeout, ngAuthSettings, SessionService) {
        this.$scope = $scope;
        this.$state = $state;
        this.neighborhoodsLength = false;
        this.SharedService = SharedService;
        this.$uibModalInstance = $uibModalInstance;
        this.modalOptions = Object.assign({}, modalOptions);
        this.$timeout = $timeout;
        this.ngAuthSettings = ngAuthSettings;
        this.sessionService = SessionService;
        this.pickupStore = false;

        try {
            this.changeLocation = this.modalOptions.locationSelected.cityId > 0 || this.modalOptions.coverageSelected > 0;
        } catch (e) {

        }
        this.domicilio = false;
        this.recogerTienda = false;

       // if (this.ngAuthSettings.site.config.header.ShowPickUpShop) this.domicilio = false;

        //seccion recoger en tienda
        this.formDataCO;
        this.coverageLocations = this.modalOptions.coverageLocations;
        this.stateCO = {};

        if (this.modalOptions.coverageSelected) {
            this.coverageLocations.forEach(value => {
                if (this.modalOptions.coverageSelected == value.id) {
                    this.formDataCO = {
                        coverageLocation: value
                    };
                }
            });
            // this.recogerTienda = true;

            // console.log("hola",this.ModalSelectPickUp);


            // this.$timeout(function() {
            //   angular.element('#boton_enviar').triggerHandler('click');
            //   }, 0);

            // this.setStorePickUpForm(this.ModalSelectPickUp);
          }

        //fin seccion recoger en tienda

        //enviar a domicilio
        this.formData = {
            country: {},
            state: {},
            city: {},
            neighborhood: {}
        };
        this.state = {};
        this.countries = this.modalOptions.locations;
        var cities = [];
        this.countries.forEach(function (val) {
            val.states.forEach(function (val2) {
                cities = cities.concat(val2.cities);
            });
        });
        this.cities = cities;

        if (this.modalOptions.locationSelected) {
            var selectedLocation = this.modalOptions.locationSelected;
            var countries = this.countries;
            var formdata = {
                country: {},
                state: {},
                city: {},
                neighborhood: {}
            };
            angular.forEach(countries, function (country, countryKey) {
                // Set the state
                angular.forEach(countries[countryKey].states, function (state, stateKey) {
                    if (selectedLocation.stateId == state.id) {
                        formdata.state = state;
                        // Set the city
                        angular.forEach(countries[countryKey].states[stateKey].cities, function (city, cityKey) {
                            if (selectedLocation.cityId == city.id) {
                                formdata.city = city;
                                formdata.cityOther = city;
                            }
                            // Set the neighborhood
                        });
                    }
                });
            });

            try {
                this.formData = formdata;
                this.formData.searchNeighborhoodtext = this.modalOptions.locationSelected.neighborhoodName;
                this.formData.neighborhood={id:this.modalOptions.locationSelected.neighborhoodId,name:this.modalOptions.locationSelected.neighborhoodName
}
            } catch (e) {
                console.log(e);
            }
        }
        //fin enviar a domicilio
    }

    $onInit() {
        this.pickupStore = this.sessionService.get('pickupStore');
    }

    setCityOther(city) {

        let neighborhood = this.formData.country.states;
        console.log(this.formData.country.states);
    neighborhood.forEach(element => {
      if(element.cities[0].neighborhoods.length >= 1){
        this.neighborhoodsLength = true;
      }
    });

        this.formData.state = this.formData.country.states.filter(function (val) {
            return val.cities.filter(function (val2) {
                return val2.id === city.id;
            })[0];
        })[0];
        this.formData.city = this.formData.state.cities.filter(function (val) {
            return val.id === city.id;
        })[0];
    }

    getNeighborhoodByFastSearch(searchNeighborhoodText) {


        var cityId = this.formData.city.id;

        this.formData.neighborhoodSelected = false;
        this.formData.neighborhoodByFastSearch = [];
        this.formData.neighborhoodSelected = false;


        this.formData.loadingNeighborhoodByFastSearh = false;
        this.formData.loadedNeighborhoodByFastSearch = false;
        this.formData.errorLoadingNeighborhoodByFastSearch = false;


        if (searchNeighborhoodText.length > 3) {
            this.formData.loadingNeighborhoodByFastSearh = true;
            this.SharedService.neighborhoodBySearchText({
                'city': cityId,
                'searchText': searchNeighborhoodText,

            }).then(response => {
                this.formData.loadingNeighborhoodByFastSearh = false;
                this.formData.loadedNeighborhoodByFastSearch = true;
                this.formData.neighborhoodByFastSearch = response;
            }).catch(reason => {
                this.formData.loadingNeighborhoodByFastSearh = false;
                this.formData.loadedNeighborhoodByFastSearch = true;
                this.formData.errorLoadingNeighborhoodByFastSearch = true;
            });
        }

    }

    setDefaultCity() {
        try {
            if (this.formData.state.cities.length === 1) {
                this.formData.city = this.formData.state.cities[0];
                this.setDefaultNeighborhood();
            }
        } catch (e) {
        }
    }

    setNeighborhood(neighborhoodByFastSearch) {
        this.formData.neighborhood = neighborhoodByFastSearch;
        this.formData.neighborhoodSelected = true;
        this.formData.searchNeighborhoodtext = neighborhoodByFastSearch.nombre;

    }


    setDefaultNeighborhood() {
        this.formData.neighborhood.id = null;
        this.formData.searchNeighborhoodtext = this.modalOptions.locationSelected.neighborhoodName;


    }

    setDefaultState() {
        try {
            if (this.formData.country.states.length === 1) {
                this.formData.state = this.formData.country.states[0];

                if (this.formData.state.cities.length === 1) {
                    this.formData.city = this.formData.state.cities[0];
                    this.setDefaultCity();
                }
            }
        } catch (e) {
        }
    }

    setDeliveryLocation(form) {
        if ((form.$valid && this.formData.city.id && this.formData.neighborhood.id)) {
            this.state = {};
            this.state.savingCoverageLocation = true;

            var countryId = '';
            var countryName = '';
            var stateId = '';
            var stateName = '';
            var cityId = '';
            var cityName = '';
            var neighborhoodId = '';
            var neighborhoodName = '';

            try {
                countryId = this.formData.country.id;
                countryName = this.formData.country.name;
            } catch (e) {
            }
            try {
                stateId = this.formData.state.id;
                stateName = this.formData.state.name;
            } catch (e) {
            }
            try {
                cityId = this.formData.city.id;
                cityName = this.formData.city.name;
            } catch (e) {
            }
            try {
                cityId = this.formData.city.id;
                cityName = this.formData.city.name;
            } catch (e) {
            }
            try {
                neighborhoodId = this.formData.neighborhood.id;
                neighborhoodName = this.formData.neighborhood.name;
            } catch (e) {
            }

            var params = {
                countryId: countryId,
                countryName: countryName,
                stateId: stateId,
                stateName: stateName,
                cityId: cityId,
                cityName: cityName,
                neighborhoodId: neighborhoodId,
                neighborhoodName: neighborhoodName
            };
            this.SharedService.setDeliveryLocation(params, null).then(response => {
                if (!response.error) {
                    this.$state.reload();

                    this.ok();
                } else {
                    this.errorLocation = true;
                    this.errorMessage = response.errorMessage;
                    this.state.savingCoverageLocation = false;

                }

            }).catch(reason => {
                this.cancel();
            });

        }else{
          this.invalidmodal=true;
        }
    }

    setStorePickUp(coverateLocation) {
        this.stateCO = {};
        this.stateCO.savingCoverageLocation = true;
    }

    setStorePickUpForm(form) {


        if ((form.$valid && this.formDataCO.coverageLocation)) {

          // console.log("hola 1",this.formDataCO.coverageLocation);
          // console.log("hola 1",this.formDataCO);
          // return

            var params = {
                countryId: '',
                countryName: '',
                stateId: '',
                stateName: '',
                cityId: '',
                cityName: '',
                neighborhoodId: '',
                neighborhoodName: '',
                coverageLocation: this.formDataCO.coverageLocation.id
            };

            this.SharedService.setDeliveryLocation(params, null).then(response => {
                if (!response.error) {
                    this.$state.reload();

                    this.ok();
                } else {
                    this.errorLocation = true;
                    this.errorMessage = response.errorMessage;
                    this.state.savingCoverageLocation = false;

                }

            }).catch(reason => {
                this.cancel();
            });
        }
    }

    clearNeighborhoodtext() {
        this.formData.searchNeighborhoodtext = "";
        this.formData.neighborhood.id = null;
    }


    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

    ok() {
        this.$uibModalInstance.close();
    }
}

ModalLocationController.$inject = inject;

export default ModalLocationController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/modal-location/modal-location.controller.js
 **/